import $ from 'jquery';

export default class CategoryQuestions {
	constructor() {
		this.listToggler = $('.category-questions__mobile-toggle');
	}

	init() {
		this.listToggler.on('click', function (event) {
			event.preventDefault();

			const hiddenList = $(this).siblings().find('.category-questions__list');

			$(this).toggleClass('category-questions__mobile-toggle_open');
			hiddenList.toggleClass('category-questions__list_open');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/category-questions/index.js